<template>
  <v-app dark>
    <v-container class="fill-height login" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="blue-grey" class="justify-center">
              <v-spacer />
              <img
                src="https://app.applysys.com.br/img/applysys-logotipo.png"
                height="40"
              />
              <v-spacer></v-spacer>
            </v-toolbar>
            <ApolloMutation
              :mutation="forgotPassword"
              :variables="{ email }"
              @done="onDone"
            >
              <template slot-scope="{ mutate, loading, error }">
                <v-card-text>
                  <!-- <v-alert type="error" v-if="error">{{ error }}</v-alert> -->
                  <v-alert type="error" v-if="error">
                    Usuario não encontrado!
                  </v-alert>
                  <v-alert type="success" v-if="passwordReseted">
                    Email de redefinição de senha enviado! Você será redirecionado para o login.
                  </v-alert>
                  <v-form>
                    <v-text-field
                      label="Email"
                      name="email"
                      prepend-icon="person"
                      type="text"
                      autocomplete="login"
                      v-model="email"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-grey"
                    dark
                    :disabled="loading || passwordReseted"
                    @click="mutate()"
                    >Enviar</v-btn
                  >
                </v-card-actions>
                <v-footer>
                  <div class="text-caption">
                    Versão {{ version }} {{ type }}
                  </div>
                  <v-spacer></v-spacer>
                  <div>&copy; ApplySys {{ new Date().getFullYear() }}</div>
                </v-footer>
              </template>
            </ApolloMutation>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import gql from "graphql-tag";
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      type: process.env.VUE_APP_TYPE,
      error: false,
      email: null,
      passwordReseted: false,
      forgotPassword: gql`
        mutation forgotPassword($email: String!) {
          resetPassword(arg1: { email: $email }) {
            code
            message
          }
        }
      `
    };
  },
  methods: {
    onDone: function() {
      this.passwordReseted = true;
      setTimeout(() => {
        this.$router.push("/", () => this.$router.go(0));
      }, 3000);
    }
  }
};
</script>

<style lang="stylus">
.login
  background url('https://www.applysys.com.br/crm/files/system/sigin-background-image.jpg') top center no-repeat
  background-size cover
  background-color black
</style>
